// decode token
// eslint-disable-next-line
import jwt_decode from "jwt-decode";
import { namesTypesTraduc } from './traducTypes'

// get type user traduc in spanish
export const getTraducTypeUser = (codeType) => {
  const type = namesTypesTraduc.filter((type) => type.code === codeType)
  return type && type.length > 0 ? type[0].name : null
}

// get name user logged
export const getNameUserLogged = () => {
  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token)
  return (
    decoded.loginAccountData?.firstName ||
    '' + ' ' + decoded.loginAccountData?.lastName ||
    ''
  )
}

// get email user logged
export const getEmailUserLogged = () => {
  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token)
  return decoded.idpData?.email
}

// return if user logged is some user for deleted of suscriber
export const isSameUserLogged = (id) => {
  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token)
  const { userId } = decoded.loginAccountData
  return userId === id
}

// verify user is typeuser ADMINISTRATOR = 'ORG-ADMIN'
export const userIsAdministrator = () => {
  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token)
  // // DEV
  // return (
  //   decoded.applicationData?.entityData?.organizationUserTypeCode ===
  //   'ORG-ADMIN'
  // )

  // PROD
  return decoded.loginAccountData?.organizationUserTypeCode === 'ORG-ADMIN'
}

export const applicationsMainteiner = ["CM", "CGI", "PER"];
